<!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    HEADER
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

<ion-header>
    <ion-toolbar>

        <!-- <ion-title mode="ios" role="heading">{{ 'MENU_HEADER' | translate}}</ion-title> -->

        <ion-buttons slot="end">
            <ion-button
                class="icon-button-accessible-background-contrast"
                [attr.aria-label]="'ARIA_LABEL_CLOSE' | translate"
                (click)="dismiss()">
                <ion-icon
                    slot="icon-only"
                    name="close"
                    aria-hidden="true"></ion-icon>
            </ion-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>

<!--///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    CONTENT
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

<ion-content>
    <br /><br />
    <div class="list-container">
        <ion-list class="list-compact">
            <ion-item button autofocus class="item-button" (click)="presentModal('stopDefinition')">
                <ion-icon name="location-outline" slot="start"></ion-icon>
                {{ 'ADD_STOPS_HELP_STOP' | translate }}
                <ion-icon name="chevron-forward-outline" aria-hidden="true" slot="end"></ion-icon>
            </ion-item>

            <ion-item button class="item-button" (click)="presentModal('instructions')">
                <ion-icon name="reader-outline" slot="start"></ion-icon>
                {{ 'ADD_STOPS_HELP_INSTRUCTIONS' | translate }}
                <ion-icon name="chevron-forward-outline" aria-hidden="true" slot="end"></ion-icon>
            </ion-item>

            <ion-item button class="item-button" (click)="presentModal('loop')">
                <ion-icon name="reload-outline" slot="start"></ion-icon>
                {{ 'ADD_STOPS_HELP_LOOP' | translate }}
                <ion-icon name="chevron-forward-outline" aria-hidden="true" slot="end"></ion-icon>
            </ion-item>
        </ion-list>
    </div>
</ion-content>
